import { z } from 'zod'

const id = z.number().int().positive()
export const historyReviewIndex = z.strictObject({
  items: z.array(z.discriminatedUnion('kind', [
    z.strictObject({ id, kind: z.literal('attendance'), title: z.string().min(1), date: z.iso.date().nullable(), year: z.null(),
      reason: z.enum(['event_needed', 'attendance_pending']), pending: z.number().int().nonnegative(), revisionNumber: z.null(), reviewPage: id }),
    z.strictObject({ id, kind: z.literal('poll_import'), title: z.string().min(1), date: z.iso.date().nullable(), year: id.nullable(),
      reason: z.enum(['context_needed', 'poll_pending']), pending: z.null(), revisionNumber: id, reviewPage: z.literal(1) }),
  ])),
  filters: z.strictObject({ kind: z.enum(['', 'attendance', 'poll_import']), q: z.string() }),
  pagination: z.strictObject({ page: id, total: z.number().int().nonnegative(), perPage: id }),
})
export type HistoryReviewIndex = z.infer<typeof historyReviewIndex>
